import { useState, useEffect } from 'react';
import { Viewer } from '@toast-ui/react-editor';
import { callService, niceCheck } from "@Utils/ServiceUtils";
import { isEmpty, getEscapeHtml } from '@Views/utils/StringUtils';

const EmploymentDetail = ({ msg, svyrEmplyPbanNo, viewChange }: any) => {

    let [svyrEmplyPbanDetail, setSvyrEmplyPbanDetail] = useState<any>({});

    const OEMPA02R01 = async () => {

        let param = {
            svyrEmplyPbanNo: svyrEmplyPbanNo
        }

        let res = await callService("OEMPA02R01", param);

        if (res['svyrEmplyPbanNo'] === undefined) {
            viewChange();
        }

        setSvyrEmplyPbanDetail({ ...res });

    }

    const onClickBtnMain = () => {
        viewChange();
    }

    const onClickBtnWrite = () => {

        niceCheck('/EmploymentWrite/' + svyrEmplyPbanNo);

    }

    useEffect(() => {
        OEMPA02R01();
    }, [svyrEmplyPbanNo]);


    return (
        <>
            <div className="wrap-body-center overflow-none">
                <div className="container container-sh">
                    <div className="container-top">
                        <div className="top-box">
                            <div className="top-box-left">
                                <h2><strong>모집공고</strong></h2>
                            </div>
                        </div>
                    </div>
                    <div className="board_detail_container detail_notice">
                        <article className="postDetial_box">
                            <div className="postTit">
                                <h3 className="tit">{svyrEmplyPbanDetail['svyrEmplyPbanNm']}</h3>
                                <div className="postInfo">
                                    <span className="hits">{svyrEmplyPbanDetail['dptNm']}</span>
                                    <span className="date">{svyrEmplyPbanDetail['svyrEmplyPbanStDtm']} ~{svyrEmplyPbanDetail['svyrEmplyPbanEndDtm']}</span>
                                </div>
                            </div>
                            <div className="post_body">
                                <section className="postTxt" style={{ paddingBottom: "20px" }}>
                                    {!isEmpty(svyrEmplyPbanDetail) && <Viewer initialValue={svyrEmplyPbanDetail['svyrEmplyPbanCtnt']} key={svyrEmplyPbanDetail['svyrEmplyPbanCtnt']} />}
                                </section>
                                {
                                    svyrEmplyPbanDetail['sttVal'] === 'P' &&
                                    <div style={{ textAlign: "center", margin: "20px" }}>
                                        <div style={{ padding: "10px 15px", lineHeight: "1.2em", backgroundColor: "#4c84ff", borderRadius: "6px", fontSize: "14px", color: "#fff", textAlign: "center", display: "inline-block", cursor: "pointer" }}>
                                            <a onClick={onClickBtnWrite}>지원서 작성</a>
                                        </div>
                                    </div>
                                }
                            </div>
                        </article>
                        <div className="boardList_shorCut" style={{ marginTop: "40px", marginBottom: "20px" }}>
                            <div className="backTolist">
                                <a className="backListBtn" style={{ cursor: "pointer" }} onClick={onClickBtnMain}>목록으로</a>
                            </div>
                        </div>
                    </div >
                </div >
            </div >
        </>
    );
}

export default EmploymentDetail;